import { Link } from "react-router-dom";
import {
    // FeedPostDropDown,
    MediaType,
    // PostMedia3,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import { CustomComponentProps, FeedPostObj } from "utils/types/general.types";

export type ThreadSubPostProps = CustomComponentProps & {
    post: FeedPostObj;
    lastThread?: boolean;
};

const ThreadSubPost = ({
    post,
    lastThread = false,
    className,
    style
}: ThreadSubPostProps) => {
    return (
        <div
            className={`card is-post relative ${className}`}
            style={{ ...style, marginBottom: lastThread ? "0" : "24px" }}
        >
            <Link
                to={`/post/${post.id}`}
                className="absolute float-link"
                style={{
                    borderRadius: lastThread ? "0 0 0.75rem 0.75rem" : "0"
                }}
            ></Link>
            {/* <!-- Main wrap --> */}
            <div className={`content-wrap`}>
                {!lastThread ? <div className="thread-post-v-line"></div> : ""}

                {/* <!-- Post header --> */}
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock user={post.user} time={post.time} />
                    {/* Right side dropdown */}
                    {/* <FeedPostDropDown /> */}
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="thread-post-body">
                    <div className="card-body">
                        {/* <!-- Post body text --> */}
                        <PostText text={post.text} />
                        {/* <!-- Featured image --> */}
                        <MediaType mediaType={post.mediaType} />
                        {/* <PostMedia3 /> */}
                    </div>
                    {/* <!-- /Post body --> */}

                    {/* <!-- Post footer --> */}
                    <div className="card-footer">
                        {/* <!-- Post statistics --> */}
                        <SocialCount
                            counts={post.socialCount}
                            postId={post.id}
                        />
                    </div>
                    {/* <!-- /Post footer --> */}
                </div>
            </div>
            {/* <!-- /Main wrap --> */}
        </div>
    );
};

export default ThreadSubPost;
